// extracted by mini-css-extract-plugin
export var formContainer = "_i8-0";
export var message = "_i8-1";